export default {
  state: () => ({
    loading: null,
  }),
  mutations: {
    setLoading(state, loading) {
      state.loading = loading;
    },
  },
  getters: {
    getLoading(state) {
      return state.loading;
    },
  },
  actions: {
    setLoading(context, loading) {
      context.commit('setLoading', loading);
    },
  },
};
